function getScrollHeight() {
  return document.body.scrollHeight;
}

const setGoogleAmpIframeHeight = () => {
  const height = getScrollHeight();

  if (height > 100) {
    // Google AMP does not allow heights below 100px
    window.parent.postMessage(
      {
        sentinel: "amp",
        type: "embed-size",
        height: height
      },
      "*"
    );
  }
};

const setIframeHeight = () => {
  const height = getScrollHeight();

  window.parent.postMessage(
    {
      type: "tdsPcInpageIframeHeight",
      height: height
    },
    "*"
  );
};

export { setGoogleAmpIframeHeight, setIframeHeight };
